import getItemUuidsWithLang from './getItemUuidsWithLang';
import getItemUuidsFromList from './getItemUuidsFromList';
import getItemUuidsById from './getItemUuidsById';
import addProductInfoProps from './addProductInfoProps';

export default ({
	form,
	languages,
	products,
	projects,
	atex,
	productCategories,
}) => {
	const body = {};

	languages.forEach((lang) => {
		body[lang.uuid] = {
			featuredImageUuid: form.featuredImage.uuid,
			featuredOrder: form.featuredOrder,
			images: getItemUuidsFromList(form.images),
			documents: getItemUuidsFromList(form.document),
			relatedProduct: getItemUuidsWithLang({ itemsToAdd: form.relatedProducts, allItems: products, langUuid: lang.uuid }),
			projects: getItemUuidsWithLang({ itemsToAdd: form.projects, allItems: projects, langUuid: lang.uuid }),
			atexes: getItemUuidsWithLang({ itemsToAdd: form.atex, allItems: atex, langUuid: lang.uuid }),
			productCategoryUuid: getItemUuidsById({ allItems: productCategories, id: form.productCategoryId, langUuid: lang.uuid }),
			productTypeUuid: form.productTypeUuid,
			videoLink: form.videoLink,
			price: form.price,
			webshop: form.webshop,
			name: form[`${lang.uuid}-name`],
			slug: form[`${lang.uuid}-slug`],
			description: form[`${lang.uuid}-description`],
			seoTitle: form[`${lang.uuid}-seoTitle`],
			seoDescription: form[`${lang.uuid}-seoDescription`],
			...addProductInfoProps({ langUuid: lang.uuid, form }),
		};
	});

	return body;
};




// WEBPACK FOOTER //
// ./src/helpers/formatProductAddBody.js